import { ReactElement, useMemo } from 'react';
import { TableRow, TableRows } from '@app/common/DataTable/types';
import { NullableNumber, NullableString } from '@app/common/types';
import OrderRow from './orderRow';
import Lang from '@lang/en';
import { List } from '../styles';

export type OrderListI = {
  rows: TableRows;
  onClick: (id: NullableNumber | NullableString) => void;
};

const emptyRowProps = {
  firstName: Lang.noRecordFoundText,
  lastName: '',
  testType: '',
  bookedDate: '',
};

const OrderList = ({ rows, onClick }: OrderListI): ReactElement => {
  const emptyRow = useMemo(() => {
    return (
      <OrderRow
        onClick={() => {
          // do nothing
        }}
        key={0}
        row={(emptyRowProps as unknown) as TableRow}
      />
    );
  }, []);

  if (!rows || rows.length === 0) {
    return emptyRow;
  }

  return (
    <List data-testid="healthcheck-order-list">
      {rows.map((row) => {
        return (
          <OrderRow
            onClick={onClick}
            key={(row.id as unknown) as number}
            row={row as TableRow}
          />
        );
      })}
    </List>
  );
};

export default OrderList;
